import React, { useEffect, useState } from 'react';
import { invoicesAPI } from '../services/api';
import { useNavigate } from 'react-router-dom';

import { Invoice } from '../types/index'; // Importing the Invoice type from types/index

const Invoices: React.FC = () => {
  const [invoices, setInvoices] = useState<Invoice[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    invoicesAPI.getAll()
      .then((res: { data: Invoice[] }) => setInvoices(res.data))
      .catch(() => setError('Failed to fetch invoices'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-8">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold">Invoices</h2>
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded shadow hover:bg-blue-700 transition"
          onClick={() => navigate('/add-invoice')}
        >
          + Add Invoice
        </button>
      </div>
      <div className="bg-white rounded-lg shadow p-6">
        {loading ? (
          <div>Loading...</div>
        ) : error ? (
          <div className="text-red-500">{error}</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-200 rounded-lg text-sm">
              <thead>
                <tr className="bg-gray-50 text-gray-500 text-xs">
                  <th className="py-3 px-4 border-b text-left">Invoice #</th>
                  <th className="py-3 px-4 border-b text-left">Client</th>
                  <th className="py-3 px-4 border-b text-left">Project</th>
                  <th className="py-3 px-4 border-b text-left">Amount</th>
                  <th className="py-3 px-4 border-b text-left">Status</th>
                  <th className="py-3 px-4 border-b text-left">Due Date</th>
                  <th className="py-3 px-4 border-b text-left">Actions</th>
                </tr>
              </thead>
              <tbody>
                {invoices.length === 0 ? (
                  <tr>
                    <td colSpan={7} className="text-center text-gray-500 py-4">No invoices found</td>
                  </tr>
                ) : (
                  invoices.map((inv) => (
                    <tr key={inv.id} className="hover:bg-gray-50">
                      <td className="py-3 px-4 border-b font-medium">{inv.invoiceNumber}</td>
                      <td className="py-3 px-4 border-b">{inv.client ? inv.client.company : '-'}</td>
                      <td className="py-3 px-4 border-b">{inv.project ? inv.project.name : '-'}</td>
                      <td className="py-3 px-4 border-b">{inv.amount}</td>
                      <td className="py-3 px-4 border-b">{inv.status}</td>
                      <td className="py-3 px-4 border-b">{inv.issuedDate ? new Date(inv.issuedDate).toLocaleDateString() : '-'}</td>
                      <td className="py-3 px-4 border-b">
                        {/* Actions: View/Edit/Delete/Mark as Paid/Download */}
                        <button className="text-blue-600 hover:underline mr-2">View</button>
                        <button className="text-green-600 hover:underline mr-2">Mark as Paid</button>
                        <button className="text-red-600 hover:underline">Delete</button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Invoices;
